import { validatedInputFieldFactory } from './validatedInputFieldFactory';

const ValidatedInput = validatedInputFieldFactory('input');

export default ValidatedInput;
